const API_BASE = process.env.REACT_APP_API_URL || '/api';
const TOKEN_KEY = 'admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(url, options = {}) {
    const resp = await fetch(`${API_BASE}${url}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
            ...options.headers,
        },
        ...options,
    });
    if (resp.status === 401) {
        clearToken();
        const err = new Error('Требуется вход');
        err.status = 401;
        throw err;
    }
    if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        const err = new Error(typeof data.detail === 'string' ? data.detail : 'Ошибка сервера');
        err.data = data;
        err.status = resp.status;
        throw err;
    }
    if (resp.status === 204) return null;
    return resp.json();
}

// ── Auth ──────────────────────────────────────────────────────────────────
export const login = async (password) => {
    const resp = await fetch(`${API_BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
    });
    if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        throw new Error(data.detail || 'Неверный пароль');
    }
    const data = await resp.json();
    setToken(data.token);
    return data;
};

// ── Services ────────────────────────────────────────────────────────────────
export const listServices = () => request('/admin/services');
export const getService = (id) => request(`/admin/services/${id}`);
export const createService = (body) => request('/admin/services', { method: 'POST', body: JSON.stringify(body) });
export const updateService = (id, body) => request(`/admin/services/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const setServiceActive = (id, is_active) => request(`/admin/services/${id}/active`, { method: 'PATCH', body: JSON.stringify({ is_active }) });
export const deleteService = (id) => request(`/admin/services/${id}`, { method: 'DELETE' });
export const serviceBookings = (id) => request(`/admin/services/${id}/bookings`);
export const deleteBooking = (id) => request(`/admin/bookings/${id}`, { method: 'DELETE' });

// ── Excel export (download with auth) ───────────────────────────────────────
export async function downloadExport(path, fallbackName) {
    const resp = await fetch(`${API_BASE}${path}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
    });
    if (resp.status === 401) { clearToken(); throw new Error('Требуется вход'); }
    if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        throw new Error(data.detail || 'Ошибка экспорта');
    }
    const blob = await resp.blob();
    const cd = resp.headers.get('Content-Disposition') || '';
    const m = cd.match(/filename="?([^"]+)"?/);
    const name = m ? m[1] : fallbackName;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = name;
    document.body.appendChild(a); a.click();
    a.remove(); URL.revokeObjectURL(url);
}

export const exportBookingsFlat = (id) => downloadExport(`/admin/services/${id}/export`, `bookings_${id}.xlsx`);
export const exportBookingsWeekly = (id, weeks) =>
    downloadExport(`/admin/services/${id}/export-weekly?weeks=${weeks}`, `bookings_weekly_${id}.xlsx`);
